// register.js — entry del bundle "proc-v0-register" (in CODA al manifest: defer,
// i globals del monolite esistono — design §2/§7.1). Tutta la logica, testabile,
// è in adapter.js; qui solo il side-effect.

import { installProcV0 } from './adapter.js';

installProcV0(window);
